export default "__VITE_ASSET__4ir2r1Xb__"